export default __webpack_public_path__ + "pdf/ACHAgreement-VW-Canada-Fr.pdf";